import styled from 'styled-components';

import { iconFill } from '../../styles/mixin';
import { Icon } from '../Icon';

export const StyledIcon = styled(Icon)`
    width: 1.25rem;
    height: 1.25rem;
    transition: all ${({ theme }) => theme.transitions.hover};
    ${({ theme }) => iconFill(theme.colors.fontSecondary)}
`;

export const Label = styled.span`
    font-size: ${({ theme }) => theme.fontSizes[0]};
`;

export const ClickableContainer = styled.button`
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    width: 2.625rem;
    transition: all ${({ theme }) => theme.transitions.hover};
    padding: 0;
    color: ${({ theme }) => theme.colors.fontSecondary};

    &:hover {
        color: ${({ theme }) => theme.colors.logoPrimary};

        ${StyledIcon} {
            ${({ theme }) => iconFill(theme.colors.logoPrimary)}
        }
    }

    &:disabled {
        cursor: not-allowed;
        color: ${({ theme }) => theme.colors.fontPrimaryDisabled};

        ${StyledIcon} {
            ${({ theme }) => iconFill(theme.colors.fontPrimaryDisabled)}
        }
    }
`;
